(function () {
  'use strict'

  require('./scss/app.scss')
  require('./scss/app-text-a-playlist.scss')

  var MODULE_NAME = 'thismoment.card.component.appTextAPlaylist'
  var templateUrl = require('./tpl/app-text-a-playlist.html')

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap'),
      require('angular-ui-mask'),
      require('./factory/sendsms-api'),
      require('../../analytics')
    ])
    .run(textAPlaylistSetup)
    .component('thismomentAppTextAPlaylist', {
      require: {
        parent: '^thismomentCard'
      },
      bindings: {
        item: '<',
        trackEvent: '&'
      },
      templateUrl: templateUrl,
      controller: textAPlaylistController
    })

  textAPlaylistSetup.$inject = ['formlyConfig']
  function textAPlaylistSetup (formlyConfig) {
    formlyConfig.setType({
      name: 'maskedInput',
      extends: 'input',
      template: '<input type="input" class="form-control" ng-model="model[options.key]">',
      defaultOptions: {
        ngModelAttrs: {
          mask: {
            attribute: 'ui-mask'
          },
          maskPlaceholder: {
            attribute: 'ui-mask-placeholder'
          },
          maskOptions: {
            attribute: 'ui-options'
          }
        },
        templateOptions: {
          maskPlaceholder: '',
          maskOptions: '{clearOnBlur:false}'
        }
      }
    })
  }

  textAPlaylistController.$inject = ['SdkConfig', '$timeout', 'SendSms', 'analyticsSDK']
  function textAPlaylistController (SdkConfig, $timeout, SendSms, analyticsSDK) {
    var vm = this

    vm.sms_success = false
    vm.sms_error = false
    vm.$onInit = textAPlaylistInit
    vm.sendSms = sendSms

    function textAPlaylistInit () {
      vm.data = {
        account_id: SdkConfig.get('account_id'),
        action: 'sms_playlist',
        phone: '',
        url: SdkConfig.get('host_url'),
        msg: vm.item.app.sms_message
      }

      vm.fields = [{
        fieldGroup: [
          {
            key: 'phone',
            type: 'maskedInput',
            templateOptions: {
              placeholder: 'Enter a phone number',
              mask: '(999) 999-9999'
            }
          }
        ]
      }]
    }

    function sendSms () {
      SendSms.save(vm.data).$promise
        .then(function () {
          clearForm(true)
        }, function () {
          clearForm(false)
        })
    }

    function clearForm (success) {
      if (success) {
        vm.sms_success = true
        $timeout(function () {
          vm.sms_success = false
        }, 2000)
        vm.trackEvent({
          action: 'Content Shared',
          properties: {
            'event trigger': 'sms-app',
            'event trigger detail': vm.data.phone
          }
        })
      } else {
        vm.sms_error = true
        $timeout(function () {
          vm.sms_error = false
        }, 2000)
      }

      vm.data.phone = ''
      vm.form.$setPristine()
      vm.form.$setUntouched()
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/app-textAPlaylist.js